module.exports = __webpack_public_path__ + "img/BSP-Banner-Transparent.c7d5e17f.png";